import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { Linking, Modal, View, Text, TouchableOpacity } from "react-native";
import AuthCodeInput from "../../components/Form/AuthCodeInput";
import ModalPaperWallet from "../../components/ModalPaperWallet";
import ModalPurchase from "../../components/ModalPurchase";
import ModalTransfer from "../../components/ModalTransfer";
import { serverDefaultUrl } from "../../services/api";
import paperWalletService from "../../services/paperWalletService";
import transferService from "../../services/transferService";
import toast from "../../utils/toast";
import styles from "./styles";
import ConfirmEmail from "../../components/ConfirmEmail/ConfirmEmail";
import { FormattedMessage, useIntl } from "react-intl";
import { id } from "date-fns/locale";
import { log } from "react-native-reanimated";
import HeaderTabs from "../../components/HeaderTabs";
import ScreenLoader from "../../components/ScreenLoader";
import { If, Then } from "react-if";
import { ActivityIndicator } from "react-native-paper";

/*
PROPS -> 
qtd float
token activeId/tokenId
userId boolean
*/

const ConfirmPasswordPaperWallet = (props) => {
  const navigation = useNavigation();
  const [password, setPassword] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [emailCode, setEmailCode] = useState();
  const [emailVerified, setEmailVerified] = useState(false);
  const [paperWalletResponse, setPaperWalletResponse] = useState();
  const [lang, setLang] = useState("pt-BR");
  const intl = useIntl();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedLanguage = await AsyncStorage.getItem("lang");
        setLang(storedLanguage || "pt-BR");
      } catch (error) {
        console.error("Erro ao ler o AsyncStorage:", error);
      }
    };

    fetchData();
  }, []);

  /* useEffect(() => {
    if (password.length === 6 && emailVerified) {
      transferToken();
    }
  }, [password, emailCode]); */

  const handleSacarPress = () => {
    setLoading(true);
    if (password.length === 6 && emailVerified) {
      transferToken();
    } else {
      toast(
        intl.formatMessage({
          id: "confirmpasswordpaperwallet.ocorreuProblema",
        }),
        "#DA1414"
      );
    }
    setLoading(true);
  };

  const transferToken = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    paperWalletService
      .store(token, {
        active_id: props.route.params.token,
        amount: props.route.params.qtd,
        password: password,
      })
      .then((response) => {
        if (response.status === 200) {
          setPaperWalletResponse(response.data);
          setModalVisible(!modalVisible);
        } else {
          if (response?.data?.message) {
            toast(response?.data?.message, "#DA1414");
          } else {
            toast(
              intl.formatMessage({
                id: "confirmpasswordpaperwallet.ocorreuProblema",
              }),
              "#DA1414"
            );
          }
        }
      })
      .catch((error) => {
        if (error.response?.data?.message) {
          toast(error.response?.data?.message, "#DA1414");
        } else {
          toast(
            intl.formatMessage({
              id: "confirmpasswordpaperwallet.ocorreuProblema",
            }),
            "#DA1414"
          );
        }
      });
  };

  return (
    <>
      <HeaderTabs
        title={
          <FormattedMessage id="confirmpasswordpaperwallet.confirmarSaque" />
        }
      />
      <View style={styles.container}>
        <Text style={styles.cardTitleTxt}>
          <FormattedMessage id="withdrawGpx.confirmacaoSaque" />
        </Text>

        <View style={styles.containerSenha}>
          <FormattedMessage id="confirmpasswordpaperwallet.digiteSenha">
            {(placeholder) => (
              <AuthCodeInput
                cellCount={6}
                isPassword={true}
                value={password}
                onValueChange={(value) => setPassword(value)}
                label={placeholder}
              />
            )}
          </FormattedMessage>
        </View>
        <ConfirmEmail
          onChange={(value) => setEmailCode(value)}
          onVerified={(value) => setEmailVerified(value)}
        />

        <View style={styles.containerBtns}>
          <TouchableOpacity
            onPress={() => navigation.goBack()}
            style={styles.btnCancelar}
          >
            <FormattedMessage id="withdrawgpxpassword.cancelar" />
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.btnConfimeSaque}
            onPress={handleSacarPress}
          >
            <FormattedMessage id="withdrawgpxpassword.sacar" />
          </TouchableOpacity>
        </View>
      </View>

      <Modal
        animationType="fade"
        transparent={false}
        visible={modalVisible}
        statusBarTranslucent={true}
        onRequestClose={() => navigation.navigate("Tabs")}
      >
        <ModalPaperWallet
          paperWalletResponse={paperWalletResponse}
          handleCloseModal={() => {
            setModalVisible(false);
            navigation.navigate("Tabs");
          }}
          handleCloseWithTransaction={() => {
            setModalVisible(false);

            if (paperWalletResponse?.code) {
              console.log(
                serverDefaultUrl +
                  "paper-wallet/view/" +
                  paperWalletResponse?.code +
                  "/" +
                  lang
              );
              Linking.canOpenURL(
                serverDefaultUrl +
                  "paper-wallet/view/" +
                  paperWalletResponse?.code +
                  "/" +
                  lang
              ).then((supported) => {
                if (supported) {
                  Linking.openURL(
                    serverDefaultUrl +
                      "paper-wallet/view/" +
                      paperWalletResponse?.code +
                      "/" +
                      lang
                  );
                } else {
                  console.log("url blocked");
                }
              });
            }

            navigation.navigate({
              name: "Tabs",
              params: { openTransaction: false },
            });
          }}
        />
      </Modal>
      <If condition={loading}>
        <Then>
          <View style={styles.loadingOverlay}>
            <ActivityIndicator size="large" color="#077A97" />
          </View>
        </Then>
      </If>
    </>
  );
};

export default ConfirmPasswordPaperWallet;
